import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMagicWand = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.291 8.338a1.485 1.485 0 0 1 2.655 1.333L5.813 19.724a1.485 1.485 0 0 1-2.655-1.333zM16.785 11.853a2.18 2.18 0 0 0-1.45-1.452 2.18 2.18 0 0 0 1.45-1.452 2.18 2.18 0 0 0 1.45 1.452 2.18 2.18 0 0 0-1.45 1.452M7.432 10.12l2.589 1.3M13.22 14.965l-.036-.098a1.35 1.35 0 0 0-.799-.8l-.098-.036.098-.037c.37-.136.662-.428.799-.799l.036-.098.036.098c.137.37.428.662.798.8l.098.036-.098.036c-.37.137-.661.43-.798.8zM14.152 6.953h-.01M3.01 10.12H3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.506 18.921c3.55-.642 7.524-4.12 8.348-7.928.819-3.78-1.912-7.117-5.669-7.492-3.778-.376-8.274 1.688-10.358 4.172"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMagicWand);
export default ForwardRef;
